import { AdminPageHeader, Form, AdminFormAction } from '@ui';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '@lp/core/auth';
import { useContext } from 'react';
import { BannedDriversForm } from '@lp/features/admin/forms/BannedDriversForm';
import {
  BANNED_DRIVERS_DEFAULT_VALUES,
  bannedDriversFormSchema,
} from '@lp/features/admin/forms/BannedDriversForm/config';
import { AdminPermissions } from '@/permissions';
import { retrieveUnifiedError } from '@/api/utils';
import { useCreateBannedDriverMutation } from '@/queries/banned-drivers';
import { DriverFormType } from '@/api/apis/resources';

export const BannedDriversCreate = () => {
  const navigate = useNavigate();
  const { mutateAsync } = useCreateBannedDriverMutation();
  const { checkPermission } = useContext(AuthContext);

  const hasCreatePermissions = checkPermission(AdminPermissions.ProvidersConfigurationCreate);

  const handleBackToList = () => {
    navigate('/admin/configuration/banned_drivers');
  };

  const handleSubmit = async (data: DriverFormType) => {
    try {
      await mutateAsync({
        firstName: data.firstName,
        lastName: data.lastName,
        affiliationType: data.affiliationType || null,
        txCenterProviderId: data.txCenterProviderId ? data.txCenterProviderId : null,
        companyName: data.companyName || null,
        phone: data.phone || '',
        comment: data.comment || '',
        isBanned: true,
      });

      toast.success(`Banned Driver created successfully.`);

      handleBackToList();
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  return (
    <Form<DriverFormType>
      defaultValues={BANNED_DRIVERS_DEFAULT_VALUES}
      schema={bannedDriversFormSchema}
      onSubmit={handleSubmit}
    >
      <div className="flex flex-col gap-9">
        <AdminPageHeader title="Add Banned Driver" backToListLink="/admin/configuration/banned_drivers">
          <AdminFormAction type="create" handleClick={handleBackToList} hasCreatePermissions={hasCreatePermissions} />
        </AdminPageHeader>
        <BannedDriversForm />
      </div>
    </Form>
  );
};
